"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _core = require("core.ui-module_site-components");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
class Recovery extends _react.default.Component {
  constructor(props) {
    super(props);
    this.state = {
      isShow: props.isShow,
      closeModal: props.closeModal
    };
  }
  toggleShow(isShow) {
    this.setState({
      isShow
    });
  }
  render() {
    const {
      isShow,
      closeModal
    } = this.state;
    const modalRoot = document.getElementById('modal-root');
    return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement("a", {
      onClick: () => {
        this.toggleShow(true);
      },
      className: ""
    }, "Disaster Recovery & Business Continuity"), isShow && /*#__PURE__*/_react.default.createElement(_core.Modal, {
      header: "Disaster Recovery & Business Continuity",
      footer: /*#__PURE__*/_react.default.createElement("div", null),
      closeModalCallback: () => {
        if (typeof closeModal !== 'undefined') {
          closeModal();
        } else {
          this.toggleShow(false);
        }
      },
      portalContainer: modalRoot
    }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("h2", null, "Overview Of Disaster Recovery And Business Continuity Plans"), /*#__PURE__*/_react.default.createElement("h3", null, "Disclosure"), /*#__PURE__*/_react.default.createElement("p", {
      align: " justify"
    }, "MissionSquare Retirement is committed to protecting the assets of our customers and being prepared to quickly recover and resume operations in the event of a significant business interruption. We have always regarded this as an obligation to our customers and have allocated resources to ensure our ability to meet this commitment. These capabilities are designed to:"), /*#__PURE__*/_react.default.createElement("ul", null, /*#__PURE__*/_react.default.createElement("li", {
      align: " justify"
    }, "Provide for the complete recovery of our technology infrastructure and data."), /*#__PURE__*/_react.default.createElement("li", {
      align: " justify"
    }, "Consider the impact of various types of potential interruptions and prepare an appropriate strategy for each."), /*#__PURE__*/_react.default.createElement("li", {
      align: " justify"
    }, "Enable MissionSquare Retirement to continue to perform our critical business functions and minimize the impact to our customers.")), /*#__PURE__*/_react.default.createElement("p", {
      align: " justify"
    }, "The goal of our Disaster Recovery Plan is to be able to recover and resume business operations within 24 hours after the onset of a situation that warrants a disaster declaration. To accomplish this we have:"), /*#__PURE__*/_react.default.createElement("ul", null, /*#__PURE__*/_react.default.createElement("li", {
      align: " justify"
    }, "Detailed plans for every division across our corporation that identify specific actions to be taken, personnel requirements to meet those actions, and other resources necessary to restore critical processes and resume business operations. Keep in mind that the ability to conduct trading and other transactional activity is dependent on the stock market being open and the availability of telecommunications to perform the trade.", ' '), /*#__PURE__*/_react.default.createElement("li", {
      align: " justify"
    }, ' ', "Contracted with a national information availability provider for alternative workspace for our personnel, network infrastructure and telecommunications infrastructure, in the event that our facility is unusable because of an incident. This enables MissionSquare Retirement to respond to your inquiries and provide information regarding your accounts during an incident."), /*#__PURE__*/_react.default.createElement("li", {
      align: " justify"
    }, "Established processes for the backup of data. Complete copies of production data are backed up at the completion of a daily processing cycle and are stored offsite at multiple secure locations. For critical data, backups are sent periodically throughout the day to a remote server. In addition, information required by regulatory agencies is archived and stored offsite at secure locations."), /*#__PURE__*/_react.default.createElement("li", {
      align: " justify"
    }, "Tested the effectiveness of our Disaster Recovery Plan to ensure that we have the ability to continue to operate in the event of an incident. Semi-annual exercises are conducted, with active annual participation of over 20% of MissionSquare Retirement employees, to test the recovery of the network infrastructure and the functionality of all critical applications and processes.")), /*#__PURE__*/_react.default.createElement("p", {
      align: " justify"
    }, "If you have any questions about this plan or MissionSquare Retirement Corporation, please contact an Investor Services Representative at", ' ', /*#__PURE__*/_react.default.createElement("strong", null, "1-800-669-7400"), "."))));
  }
}
exports.default = Recovery;
Recovery.propTypes = {
  isShow: _propTypes.default.bool,
  closeModal: _propTypes.default.func
};
Recovery.defaultProps = {
  isShow: undefined,
  closeModal: undefined
};
//# sourceMappingURL=Recovery.js.map